import { render, staticRenderFns } from "./IncorrectIcon.vue?vue&type=template&id=755422bb&scoped=true&"
import script from "./IncorrectIcon.vue?vue&type=script&lang=js&"
export * from "./IncorrectIcon.vue?vue&type=script&lang=js&"
import style0 from "./IncorrectIcon.vue?vue&type=style&index=0&id=755422bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755422bb",
  null
  
)

component.options.__file = "IncorrectIcon.vue"
export default component.exports